import React from "react";
import "./timemodal.css";
import { useTranslation } from "react-i18next";
import i18n from "../Components/i18n";
export default function TimeBox({

  data,
  setTimeBoxPopUp,
  setTimeEditData,
  setTimeArr,
  isDisabledAll
}) {
    const { t } = useTranslation();


  const deleteFun = (time) => {
    setTimeArr((prev) => prev.filter((el) => el.time !== time));
  };

  return (
    <div style={styles.card}>
      <div style={styles.timeBox}>
        <div style={styles.timeRow}>
          <div style={styles.time}>
            <p style={styles.timeText}>{data?.time?.split("T")[0]}</p>
          </div>
          <div style={styles.toText}>
            <p style={styles.toTextStyle}>to</p>
          </div>
          <div style={styles.time}>
            <p style={styles.timeText}>{data?.time?.split("T")[1]}</p>
          </div>
          <div style={styles.switchContainer}>
            <label className="switch" style={{ cursor: "none" }}>
              <input
                style={{ cursor: "none" }}
                type="checkbox"
                checked={data?.status}
                onChange={(e) => {}}
                name="loading"
              />
              <span className="slider" style={{ cursor: "auto" }}></span>
            </label>
          </div>
        </div>

      <div style={styles.dayCircles}>
  {(i18n.language === "he"
    ? [t("S2"), t("F"), t("T2"), t("W"), t("T"), t("M"), t("S")] // Hebrew: Sat to Fri
    : [t("S"), t("M"), t("T"), t("W"), t("T2"), t("F"), t("S2")] // Default: Sun to Sat
  ).map((el, index) => {
    // Use correct day index for styling
    const dayIndex = i18n.language === "he"
      ? [6, 5, 4, 3, 2, 1, 0][index] // Mapping to actual day indices
      : index;

    return (
      <div
        key={index}
        style={{
          ...styles.dayCircle,
          borderColor: data?.days?.indexOf(dayIndex) > -1 ? "#4CAF50" : "#ccc",
          background: data?.days?.indexOf(dayIndex) > -1 ? "#A5D6A7" : "#e50000",
          color: "#fff",
        }}
      >
        {el}
      </div>
    );
  })}
</div>


        <div style={styles.buttonsContainer}>
          <button
          //disabled={isDisabledAll}
            style={styles.deleteButton}
            onClick={() => {
              deleteFun(data.time);
            }}
          >
            <div style={styles.icon} />
            <span>{t("Delete")}</span>
          </button>

          <button
                    //disabled={isDisabledAll}

            style={styles.editButton}
            onClick={() => {
              setTimeBoxPopUp(true);
              setTimeEditData(data);
            }}
          >
            <div style={styles.icon} />
            <span>{t("Edit")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: "flex",
    justifyContent: "center",
    padding: "10px",
    margin: "0px",
  },
  timeBox: {
    background: "rgba(255, 255, 255, 0.2)", // Light green background for freshness
    borderRadius: "8px",
    padding: "20px",
    width: "260px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)", // Subtle shadow for modern look
  },
  timeRow: {
    display: "grid",
    gridTemplateColumns: "0fr 0fr 0fr 3.5fr",
    gap: "15px",
  },
  time: {
    display: "flex",
    justifyContent: "center",
  },
  timeText: {
    color: "#3E4A52",
    fontWeight: "700",
    fontSize: "100%",
  },
  toText: {
    display: "flex",
    justifyContent: "center",
  },
  toTextStyle: {
    color: "#9E9E9E",
    fontWeight: "500",
    fontSize: "100%",
  },
  dayAndSwitch: {
    display: "grid",
    gridTemplateColumns: "3fr 1fr",
    gap: "12px",
    justifyItems: "center",
    alignItems: "center",
  },
  days: {
    textAlign: "center",
  },
  daysText: {
    color: "#3E4A52",
    fontSize: "100%",
    fontWeight: "500",
  },
  switchContainer: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "50%",
  },
  switch: {},
  dayCircles: {
    display: "flex",
    gap: "5px",
    justifyContent: "center",
    fontSize: "80%",
  },
  dayCircle: {
    width: "25px",
    height: "25px",
    borderRadius: "50%",
    border: "2px solid #ccc", // Default border color
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    textAlign: "center",
    background: "#fff", // Default background
    transition: "background-color 0.3s, border-color 0.3s", // Smooth transition
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    marginTop: "10px",
  },
  deleteButton: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(45deg, #8ec0fc, #8ec0fc, #8ec0fc,#8ec0fc)", // Red color for delete button
    color: "#000",
    border: "none",
    borderRadius: "4px",
    padding: "0px 10px",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "90%",
    transition: "background-color 0.3s",
  },
  editButton: {
    display: "flex",
    alignItems: "center",
    background: "linear-gradient(45deg, #8ec0fc, #8ec0fc, #8ec0fc,#8ec0fc)",
    color: "#000",
    border: "none",
    borderRadius: "4px",
    padding: "5px 15px",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "90%",
    transition: "background-color 0.3s",
  },
  icon: {
    marginRight: "5px",
    fontSize: "100%",
  },
};
